import ProductPlaceholderImage from '../Assets/img/placeholder.svg';


const addDefaultImgSrc = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.src = ProductPlaceholderImage;
}

export { addDefaultImgSrc }